import { render, staticRenderFns } from "./Descripcion.vue?vue&type=template&id=409cbfba&scoped=true&lang=pug&"
import script from "./Descripcion.vue?vue&type=script&lang=js&"
export * from "./Descripcion.vue?vue&type=script&lang=js&"
import style0 from "./Descripcion.vue?vue&type=style&index=0&id=409cbfba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409cbfba",
  null
  
)

export default component.exports